// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2R91W","cardLogo":"styles_cardLogo__1qb8U","cardText":"styles_cardText__3YDnm"};